
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { downloadOfferFile, acceptOffer, getUserByLoginId, getofferDetails, getPersonalDetails, offerAccepted, getFamilyDetails, getEducationDetails, getUserDocumentDetails, getDesignation, getExperienceDetails } from '../../Redux/NewHire/Action';
import { USER_DETAILS, EMP_USER_DETAILS } from '../../Redux/NewHire/ActionType';
import { useNavigate } from 'react-router-dom';
import { FaDownload, FaFilePdf } from 'react-icons/fa6';
import { FaCheckCircle } from "react-icons/fa";
import { format } from "date-fns";
import { fetchClientDetails } from '../../Redux/Config/Action';
import { UseGeneratePDF } from '../Employee/UseGeneratePDF';


const CandidateDash = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { auth } = useSelector((store) => store);
  const [activeTab, setActiveTab] = useState("data1");
  const token = localStorage.getItem("token");
  const loginId = localStorage.getItem("loginId");
  const role = localStorage.getItem("role");
  const [generatePdfFlag, setGeneratePdfFlag] = useState(false);
  const [userdesignation, setUserdesignation] = useState("");
  const { userDetails, offerDetails, personalDetails, familyListDetails, educationListDetails, userdocslist, desiglist, empUserDetails, experienceListDetails } = useSelector(
    (store) => store.newHireData
  );
  const { clientDetails } = useSelector((store) => store.config);
  const { generatePDF } = UseGeneratePDF();



  const [userData, setUserData] = useState({
    loginId: "",
    firstName: "",
    lastName: "",
    personalEmail: "",
    pan: "",
    dob: "",
    designationId: "",
  });

  useEffect(() => {
    if (userDetails) {
      setUserData({
        loginId: userDetails.loginId || "",
        firstName: userDetails.firstName || "",
        lastName: userDetails.lastName || "",
        personalEmail: userDetails.personalEmail || "",
        dob: userDetails.dob || "",
        pan: userDetails.pan || "",
        designationId: userDetails.designationId || "",
      });
      dispatch(getofferDetails(loginId, token));
    }
  }, [userDetails]);

  useEffect(() => {
    dispatch(getPersonalDetails(loginId, token));
    dispatch(getFamilyDetails(loginId, token));
    dispatch(getEducationDetails(loginId, token));
    dispatch(getUserDocumentDetails(loginId, token));
    dispatch(getDesignation(token));
  }, [dispatch, loginId, token]);

  const handleViewClick = async () => {
    const designation = desiglist.find(
      (desig) => desig.designationId === userDetails.designationId
    );

    if (designation) setUserdesignation(designation.designationName);
    await Promise.all([
      dispatch(getUserByLoginId(loginId, token, EMP_USER_DETAILS)),
      dispatch(getExperienceDetails(loginId, token)),
      dispatch(fetchClientDetails(token)),
    ]);
    setGeneratePdfFlag(true);
  };

  useEffect(() => {
    if (generatePdfFlag) {
      if (
        empUserDetails &&
        personalDetails &&
        familyListDetails &&
        educationListDetails &&
        experienceListDetails &&
        clientDetails
      ) {
        generatePDF(
          empUserDetails,
          personalDetails,
          familyListDetails,
          educationListDetails,
          experienceListDetails,
          clientDetails,
          userdesignation,
          userdocslist,
        );
        setGeneratePdfFlag(false);
      }
    }
  }, [
    empUserDetails,
    personalDetails,
    familyListDetails,
    educationListDetails,
    experienceListDetails,
    clientDetails,
    generatePdfFlag,
    UseGeneratePDF,
  ]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };


  const hireDetails = () => {
    navigate("/newHireDetails", { state: { rowData: userData } });
  };

  const handleDownload = (fileName, loginId) => {
    dispatch(downloadOfferFile(loginId, fileName, token));
  };

  const handleFinalSubmission = async (e) => {
    e.preventDefault();

    const user = {
      userId: userDetails.loginId,
      UserName: userDetails.username,
    };

    if (!personalDetails || personalDetails.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Incomplete Submission",
        text: "Please complete the auto-boarding process before submitting.",
      });
    } else {
      const result = await Swal.fire({
        title: "Terms and Conditions",
        html: `
        <div style="text-align: left;">
          <p>Before submitting, please review the following terms and conditions:</p>
          <p>- You confirm that all the data provided is accurate and complete.</p>
          <p>- After the final submission, no further modifications will be allowed.</p>
          <p>- Your submission will be reviewed, and you will be notified if any issues arise.</p>
        </div>
        <div style="text-align: left;">
          <input type="checkbox" id="agreeCheckbox" style="margin-right: 10px;" />
          <label for="agreeCheckbox">I agree to the terms and conditions</label>
        </div>
      `,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Submit",
        cancelButtonText: "Cancel",
        preConfirm: () => {
          const agreeCheckbox = document.getElementById("agreeCheckbox");
          if (!agreeCheckbox.checked) {
            Swal.showValidationMessage(
              "You must agree to the terms and conditions to continue."
            );
            return false;
          }
          return true;
        },
      });

      if (result.isConfirmed) {
        Swal.fire({
          title: "Submitting...",
          text: "Please wait while we process your request.",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        dispatch(acceptOffer(user, token))
          .then(({ success }) => {
            if (success) {
              dispatch(getUserByLoginId(loginId, token, USER_DETAILS));
              dispatch(getofferDetails(loginId, token));
              dispatch(getPersonalDetails(loginId, token));
              Swal.fire({
                title: "Success!",
                text: "Final data submitted successfully.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false,
              });
            } else {
              Swal.fire({
                title: "Error!",
                text: "Final data submission was unsuccessful.",
                icon: "error",
                confirmButtonText: "OK",
              });
            }
          })
          .catch(() => {
            Swal.fire({
              title: "Error!",
              text: "There was an error submitting the final data.",
              icon: "error",
              confirmButtonText: "OK",
            });
          });
      }
    }
  };

  const handleAcceptClick = async (e) => {
    e.preventDefault();

    const result = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    });
    if (result.isConfirmed) {
      Swal.fire({
        title: "Submitting...",
        text: "Please wait while we process your request.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      dispatch(offerAccepted(userDetails.loginId, token))
        .then(({ success }) => {
          if (success) {
            dispatch(getofferDetails(loginId, token));
            Swal.fire({
              title: "Success!",
              text: "Offer Accepted successfully",
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Offer Accepted unsuccessfully",
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        })
        .catch(() => {
          Swal.fire({
            title: "Error!",
            text: "Something went wrong. Please try again later.",
            icon: "error",
            confirmButtonText: "OK",
          });
        });
    }

  }

  const hasData = (val) => {
    if (Array.isArray(val)) return val.length > 0;
    if (val && typeof val === "object") return Object.keys(val).length > 0;
    return false;
  };


  return (
    <div className="card3 shadow-lg border-0 stylish-card">
      <div className="card-header p-3 stylish-card-header">
        <ul className="nav nav-tabs card-header-tabs stylish-nav-tabs">
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === "data1" ? "active" : ""
                }`}
              onClick={() => handleTabClick("data1")}
            >
              Auto-Boarding
            </button>
          </li>
          {(offerDetails && offerDetails.offerId) && (
            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "data2" ? "active" : ""
                  }`}
                onClick={() => handleTabClick("data2")}
              >
                Offer
              </button>
            </li>
          )}
          {(offerDetails && offerDetails.status === "Offer Accepted") && (

            <li className="nav-item">
              <button
                className={`nav-link ${activeTab === "data3" ? "active" : ""
                  }`}
                onClick={() => handleTabClick("data3")}
              >
                Joining
              </button>
            </li>
          )}
        </ul>
      </div>

      <div className="card-body stylish-card-body">
        {activeTab === "data1" && (
          <div>
            <div className="card2">
              <div className="card-body">
                <div className="row">
                  <div className="col-12 col-md-5">
                    <div className="card2 p-3 text-center">
                      <img
                        src="./images/onboard.jpg"
                        alt="Employee"
                        className="img-fluid rounded-circle"
                        style={{ maxWidth: "270px", margin: "0 auto" }}
                      />
                    </div>
                  </div>

                  <div className="col-12 col-md-7">
                    <div className="card2 p-5">
                      <h4 className="text-primary">
                        Welcome, {userData.firstName} {userData.lastName}
                      </h4>
                      <p className="mb-1">
                        <strong>
                          Welcome to Vedant Tech Solutions On-Boarding
                          Portal
                        </strong>
                      </p>
                      <p className="mb-3">
                        We are glad to have you on board.
                      </p>
                      <button
                        className={`btn ${userDetails?.status !== "A" ? "btn-primary" : "btn-success"}`}
                        onClick={userDetails?.status !== "A" ? hireDetails : undefined}
                      >
                        {userDetails?.status === "A" && <FaCheckCircle className="me-2 mb-1" />}
                        {userDetails?.status === "A" ? "DETAILS SUBMITTED" : "FILL YOUR DETAILS"}
                      </button>

                    </div>
                  </div>
                </div>
                <div className="row" style={{ marginBottom: "-25px" }}>
                  <div className="col-12">
                    <p className="text-muted">
                      <strong className='text-danger'>Note:</strong> After you fill and verify all Auto-Boarding details, make Final Submission. You won’t be able to modify anything afterward.
                    </p>
                  </div>
                </div>
                <hr></hr>
                <div className="row" style={{ margin: "-10px" }}>
                  <div className="col-12 text-center">
                    {userDetails?.status !== "A" &&
                      <button
                        className="btn btn-success me-2"
                        onClick={handleFinalSubmission}
                        disabled={!(hasData(personalDetails) && hasData(familyListDetails) && hasData(educationListDetails) && hasData(userdocslist))}
                      >
                        FINAL SUBMISSION
                      </button>
                    }
                    {userDetails?.status === "A" && (<button
                      className="btn btn-primary"
                    onClick={handleViewClick}
                    >
                      PREVIEW PDF <FaFilePdf />
                    </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {activeTab === "data2" && (
          <div>
            <div className="table-responsive">
              <h5 className="card-title text-center mt-3 mb-3 text-primary">
                Offer Details
              </h5>
              {offerDetails && offerDetails.joiningDate ? (
                <>
                  <table className="table table-bordered">
                    <thead>
                      <tr className='tablecell text-white'>
                        <th >
                          Joining Date
                        </th>
                        <th >
                          Offer Letter
                        </th>
                        <th > Offer Acceptance Date</th>
                        <th>Preview</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{offerDetails.joiningDate}</td>
                        <td>{offerDetails.offerAttachmentFileName}</td>
                        <td>
                          {offerDetails.status === "Offer Accepted"
                            ? format(new Date(offerDetails.modifiedDate), "dd-MM-yyyy hh:mm a")
                            : "-"}
                        </td>
                        <td>
                          <button
                            onClick={() =>
                              handleDownload(
                                offerDetails.offerAttachmentFileName,
                                loginId
                              )
                            }
                            className="no-border-button"
                          >
                            <FaDownload className="download-icon" />
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {offerDetails.status !== "Offer Accepted" && (
                    <div className="text-center">
                      <button
                        className="btn btn-success me-3"
                        onClick={handleAcceptClick}
                      >
                        ACCEPT OFFER
                      </button>
                    </div>
                  )}
                </>
              ) : (
                <p className="text-center text-danger mt-3">
                  No offer details available
                </p>
              )}
            </div>
          </div>
        )}

        {activeTab === "data3" && (
          <div>
            <h5 className="card-title text-danger">Joining Details</h5>
            {offerDetails && offerDetails.joiningDate ? (
              <div>
                <p className="text-success mt-3">
                  🎉 Congratulations! We are thrilled to welcome you to{" "}
                  <strong>Vedant Tech Solutions</strong>. Your journey
                  with us officially begins on{" "}
                  <strong>{offerDetails.joiningDate}</strong>.
                </p>
                <p className="text-primary">
                  We’re excited to have you onboard and can’t wait to see
                  the amazing things you’ll accomplish with us.<br></br>
                  Please feel free to reach out if you have any questions
                  as you prepare for your first day.<br></br>
                  Welcome to the team, and here's to a bright and
                  successful future together!
                </p>
              </div>
            ) : (
              <p className="text-warning">
                No joining details available.
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default CandidateDash;